module.exports = __webpack_public_path__ + "cde9cb3b406d089f97889aedaf21c0d1.svg";